var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowcase({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 350,
    viewBox: "0 0 400 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.891 141.151L139.453 82.967C143.337 79.0409 149.669 79.0068 153.595 82.891L224.8 153.334C232.792 151.205 239.878 151.249 245.178 153.775C244.057 151.767 242.638 149.882 240.921 148.184L164.145 72.2276C154.329 62.5171 138.5 62.6022 128.79 72.4176L71.2276 130.602C61.5171 140.417 61.6022 156.246 71.4176 165.957L148.194 241.913C150.082 243.78 152.191 245.285 154.437 246.428C151.377 241.201 151.052 233.95 153.109 225.674L81.967 155.293C78.0409 151.409 78.0068 145.077 81.891 141.151Z",
    fill: "#EA3377"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M243.28 160.17C246.207 163.097 247.762 169.962 243.643 181.668C239.723 192.804 231.329 205.956 219.143 218.143C206.956 230.33 193.804 238.723 182.667 242.643C170.962 246.763 164.097 245.206 161.17 242.279C158.243 239.352 156.687 232.487 160.806 220.782C164.726 209.645 173.12 196.494 185.306 184.307C197.493 172.12 210.645 163.726 221.782 159.807C233.487 155.687 240.352 157.243 243.28 160.17Z",
    stroke: "#EA3377",
    strokeWidth: 15
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.5 0L133.5 133C133.5 141.284 140.216 148 148.5 148C156.784 148 163.5 141.284 163.5 133L163.5 0H133.5ZM148.5 141C152.918 141 156.5 137.418 156.5 133C156.5 128.582 152.918 125 148.5 125C144.082 125 140.5 128.582 140.5 133C140.5 137.418 144.082 141 148.5 141Z",
    fill: "#EA3377"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M246 241L296 291",
    stroke: "#93E54B",
    strokeWidth: 25,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M211 268L240.884 332.086",
    stroke: "#FF3131",
    strokeWidth: 25,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M275 207L339.086 236.884",
    stroke: "#68ADE5",
    strokeWidth: 25,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.162 69.3145C133.979 69.1196 133.793 68.9269 133.602 68.7365L132.188 67.3223C122.425 57.5592 106.596 57.5592 96.8326 67.3223L68.3223 95.8326C58.5592 105.596 58.5592 121.425 68.3223 131.188L69.7365 132.602C69.9269 132.793 70.1196 132.979 70.3145 133.162L80.9347 122.542C80.732 122.369 80.5347 122.187 80.3431 121.996L78.9289 120.581C75.0237 116.676 75.0237 110.344 78.9289 106.439L107.439 77.9289C111.344 74.0237 117.676 74.0237 121.581 77.9289L122.996 79.3431C123.187 79.5347 123.369 79.732 123.542 79.9347L134.162 69.3145Z",
    fill: "#EA3377"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowcase);
export default __webpack_public_path__ + "static/media/showcase.678e4128fa744d54a4b56ec9e8ae0b90.svg";
export { ForwardRef as ReactComponent };